import React, { useState } from 'react';
import  { useBarcode } from '@createnextapp/react-barcode';
import { ExistenciaSucursal } from './Chunks.js';

const Getcodigo = (props) => {
	let codigo = props.producto.codigo;
	const { inputRef } = useBarcode({
		value: props.producto ? codigo : '',
		options: {
			  background: '#ffffff',
			  width : 2,
			  height : 100,
			  text : ( codigo+' $'+props.producto.precio )
		}
	})
	let url;
	if( inputRef.current){
		url = inputRef.current.src;
	}
	return <>
			<img ref={inputRef} alt="Codigo"/><br/>
			<a download={'codigo-'+codigo+'.png'} href={url} className="btn-small-2">Descargar</a>
		</>;
}
const EditProductModal = (props)=>{
	const { 
		visible, 
		submit, 
		close, 
		producto, 
		handler,
		sucursales, 
		sesion,
		resta,
		blurCodigo,
		errorcodigo,
		adminStock
	} = props;
	
	const [open, setOpen] = useState(false);
	let ver = {
		'display' : 'block'
	}
	let ocultar = {
		'display' : 'none'
	}
	
	return(
		<div className={visible ? 'overlay show':'overlay'} style={{zIndex:'2'}}>
			<form onSubmit={submit} className="row content" style={{'width':'90%'}}>
				<div className="modal_header">
					<h5>Editar</h5>
					<span className="close-pop-up" onClick={close}>x</span>
				</div>
				<div className="modal_body">
					<div className="xs-12 sm-12 md-6 lg-6">
						<div className="xs-12 sm-12 md-12 lg-12 text-center">
							<h3>Detalles</h3><br/>
						</div>
						<div className="xs-12 sm-12 md-12 lg-12">
							<label>
								<input type="text" onChange={handler} name="nombre" value={producto.nombre} placeholder=" "/>
								<span>Descripción</span>
							</label>
						</div>
						<div className="xs-12 sm-12 md-6 lg-6">
							<label>
								<input type="text" className={errorcodigo ? '': 'error-input' } onChange={handler} onBlur={blurCodigo} name="codigo" value={producto.codigo||''} placeholder=" "/>
								{	errorcodigo ? '' : <small className="error-full-box">El código ya existe</small> }
								<span>Cód. de Prod.</span>
							</label>
						</div>
						<div className="xs-12 sm-12 md-6 lg-6">
							<label>
								<input type="text" onChange={handler} name="precio" value={producto.precio} placeholder=" "/>
								<span>Precio ($)</span>
							</label>
						</div>
						<div className="xs-12 sm-12 md-12 lg-12">&nbsp;</div>
						<div className="xs-12 sm-12 md-6 lg-6">
							<label>
								<input 
									min="0"
									max="5000"
									type="number"
									name="stockinv"
									placeholder=" "
									onChange={handler} 
									value={producto.stockinv||''}
								/>
								<span>Stock (Sucursal 65 Bodega)</span>
							</label>
						</div>
						<div className="xs-12 sm-12 md-6 lg-6">
							<label>
								<div className="input-text">{producto.stock}</div>
								<span className="fixed">Stock (Sucursal 65 Bodega)</span>
							</label>
						</div>
						<div className="xs-12 sm-12 md-12 lg-12 text-right">
							<div style={{'top':'0px','position':'relative'}}>
								<span onClick={()=>adminStock('+')} className="btn-small-2">Agregar</span>
								<span onClick={()=>adminStock('-')} className="btn-small-2" style={{'marginLeft':'5px'}}>Restar</span>
							</div>
						</div>
						<div></div>
						<div className="xs-12 sm-6 md-6 lg-6 text-center">
							<h4>Código de Barras</h4>
							{ open ? 
								'':
								<span className="btn-small-2" onClick={()=>setOpen(true)}>Generar Código</span>
							}
							<div style={ open ? ver : ocultar } >
								{ producto.codigo ? <Getcodigo producto={producto} show={open}></Getcodigo> : '' }
							</div>
						</div>
						<div className="xs-12 sm-6 md-6 lg-6 text-center"><br/>
							{ errorcodigo ?
								<button type="submit" className="btn btn-green">Guardar</button>
								: <span className="btn-lock-save">Guardar</span>
							}
						</div>
					</div>
					<div className="xs-12 sm-12 md-6 lg-6">
						<div className="xs-12 sm-12 md-12 lg-12">
							<h3 className="title-existencias text-center">Existencias</h3><br/>
							<div style={{'height':'500px','overflow':'scroll'}}>
								<ExistenciaSucursal 
									sucursales={sucursales}
									existencias={producto.sucursales}
									handler={handler}
									sesion={sesion}
									resta={resta}
								/>
							</div>
						</div>
					</div>
				</div>
			</form>
		</div>
	)
}
export default EditProductModal;